import { objectToFormData } from "../utils";
import Api from "./axiosVersion1";
import {
  appendQueryString,
  buildQueryString,
  buildRepeatedQueryParam,
  createAbortSignalController,
  formUrlEncodedConfig,
} from "./serviceUtils";

let controller;

// export const getCards = async (board_id) => {
//   return await Api.get(`/cards/${board_id}`);
// };

export const getCards = async (board_id) => {
  return await Api.get(`/cards/${board_id}`);
};

export const createCard = async (data) => {
  return await Api.post(`/card`, data, formUrlEncodedConfig);
};

export const assignCard = async ({ card_id, data }) => {
  return await Api.put(
    appendQueryString(`/card_assign`, buildQueryString({ card_id })),
    data,
    formUrlEncodedConfig
  );
};

export const updateCard = async ({ card_id, data }) => {
  return await Api.put(`/card/${card_id}`, objectToFormData(data));
};

export const createCardAttachment = async (data) => {
  return await Api.post(`/card_attachment`, data);
};

export const getCard = async (card_id) => {
  return await Api.get(`/card/${card_id}`);
};

export const getCardAttachment = async (card_id) => {
  return await Api.get(`/card_attachment/${card_id}/card_id`);
};

export const downloadCardAttachment = async (attachmenId) => {
  return await Api.get(`/download/card-attachment/${attachmenId}`);
};

export const deleteCardAttachment = async (attachment_id) => {
  return await Api.delete(`/card_attachment/${attachment_id}`);
};

export const getMyCards = async (
  user,
  checkedList,
  epics,
  reporterCards,
  workflow_id,
  unassigned_task,
  boards
) => {
  controller = createAbortSignalController(controller);
  const signal = controller.signal;

  const boardQuery = buildRepeatedQueryParam("boards", checkedList);
  const epicQuery = buildRepeatedQueryParam("epics", epics);
  const userQuery = buildRepeatedQueryParam(
    "user_ids",
    user.map((item) => item.user_id)
  );
  const selectedBoardsQuery =
    boards && boards.length > 0
      ? buildRepeatedQueryParam("boards", boards)
      : "";
  const flagsQuery = buildQueryString({
    include_reporter: reporterCards === "true" ? true : undefined,
    unassigned_task: unassigned_task === true ? true : undefined,
  });

  if (
    workflow_id
  ) {
    const query = [
      buildQueryString({ workflow_id }),
      boards && boards?.length > 0 ? selectedBoardsQuery : "",
      userQuery,
      boardQuery,
      epicQuery,
      flagsQuery,
    ]
      .filter(Boolean)
      .join("&");

    return await Api.get(
      appendQueryString(`/cards_by_users`, query),
      {
        signal: signal,
      }
    );
  }
};

export const getUserCards = async (userId, board, workflow) => {
  return await Api.get(
    appendQueryString(
      `/cards_by_users`,
      buildQueryString({
        user_ids: userId,
        board_id: board,
        workflow_id: workflow,
      })
    )
  );
};

export const deleteCard = async (card_id) => {
  return await Api.delete(`/card/${card_id}`);
};

export const createAndUpdateLabel = async ({ card_id, data }) => {
  return await Api.post(
    `/card/labels?card_id=${card_id}`,
    objectToFormData(data)
  );
};

export const AddToWatchList = async (card_id) => {
  return await Api.post(
    "/watchlist",
    {
      card_id: card_id,
    },
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }
  );
};

export const RemoveToWatchList = async (card_id) => {
  return await Api.delete("/watchlist", {
    data: { card_id: card_id },
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
  });
};

export const createCardsFromCSV = async (data) => {
  return await Api.post(`/cards_from_csv`, data);
};

export const getSubTasks = async (cardId) => {
  return await Api.get(`/subtasks/${cardId}`);
};

export const addSubtask = async (data) => {
  return await Api.post(
    `/add-subtasks?parent_card_id=${data.parentId}&child_card_id=${data.childId}`
  );
};

export const manageColumnOrder = async (data) => {
  return await Api.post(`/card/field-sequence`, data);
};

export const updateWorkflowStep = async ({ card_id, workflow_step_id }) => {
  return await Api.put(
    `/change_workflow_step`,
    { card_id: card_id, workflow_step_id: workflow_step_id },
    formUrlEncodedConfig
  );
};

export const updateWorkflowIncolumn = async ({card_id, workflow_step_id, after_card_id, next_card_id }) =>{
  return await Api.put(
    `/cards/move`,
    {card_id: card_id, workflow_step_id: workflow_step_id, after_card_id: after_card_id, next_card_id: next_card_id},
    formUrlEncodedConfig
  )
}

export const updateParentCard = async ({ card_id, parent_card_id }) => {
  return await Api.put(
    `/change_parent`,
    { card_id: card_id, parent_card_id: parent_card_id },
    formUrlEncodedConfig
  );
};

export const updateBoard = async ({ card_id, board_id, workflow_step_id }) => {
  return await Api.put(
    `/change_board`,
    {
      card_id: card_id,
      board_id: board_id,
      workflow_step_id: workflow_step_id,
    },
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    }
  );
};


export const getAssignedCards = async (userId) => {
  if (controller) {
   controller.abort();
  }

  controller = new AbortController();
  const signal = controller.signal;

  return await Api.get(`/cards_by_users?user_ids=${userId}&not_done=true`, {
    signal: signal,
  })
}

export const updateCardCustomField = async (card_id, data) => {
  return await Api.put(`/card/${card_id}/custom-field`, data,
    {
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
    });
};
